import { render, staticRenderFns } from "./housekeepingTypeManage.vue?vue&type=template&id=5dcbc066&scoped=true"
import script from "./housekeepingTypeManage.vue?vue&type=script&lang=js"
export * from "./housekeepingTypeManage.vue?vue&type=script&lang=js"
import style0 from "./housekeepingTypeManage.vue?vue&type=style&index=0&id=5dcbc066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcbc066",
  null
  
)

export default component.exports